import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={20}
      height={16}
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M17.405 2.75h-2.063l-1.138-1.719A2.367 2.367 0 0012.248 0H7.521c-.774 0-1.526.387-1.956 1.031l-1.138 1.72H2.364A2.357 2.357 0 000 5.113v8.338a2.357 2.357 0 002.364 2.363h15.041a2.357 2.357 0 002.364-2.363V5.114a2.357 2.357 0 00-2.364-2.364zm-7.52 11.131a5.328 5.328 0 01-5.33-5.329c0-2.944 2.386-5.307 5.33-5.307a5.328 5.328 0 015.329 5.329c0 2.922-2.386 5.307-5.33 5.307zm7.22-7.8h-.946a.7.7 0 010-1.397h.86c.386-.021.709.28.73.667a.68.68 0 01-.644.73z"
        fill="#333"
      />
      <Path
        d="M9.883 5.608a2.971 2.971 0 00-2.965 2.966c0 1.633 1.332 2.944 2.965 2.944a2.971 2.971 0 002.966-2.966c0-1.633-1.333-2.944-2.966-2.944z"
        fill="#333"
      />
    </Svg>
  );
}

export default SvgComponent;
